import { render, staticRenderFns } from "./APHistory.vue?vue&type=template&id=8ef69c52&scoped=true&"
import script from "./APHistory.vue?vue&type=script&lang=js&"
export * from "./APHistory.vue?vue&type=script&lang=js&"
import style0 from "./APHistory.vue?vue&type=style&index=0&id=8ef69c52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef69c52",
  null
  
)

component.options.__file = "APHistory.vue"
export default component.exports